module.exports = __webpack_public_path__ + "static/hero_two-5cb9a98ca8da89b8e6f5933279693156.png";